import { create } from "zustand";

interface OtpVerifyStore {
  isOtpVerified: boolean;
  setIsOtpVerified: (value: boolean) => void;
}

export const useOtpVerifiedStore = create<OtpVerifyStore>((set) => ({
  isOtpVerified: false,
  setIsOtpVerified: (value) => set({ isOtpVerified: value }),
}));
